import { SubmitFooterActions, type SubmitFooterActionsProps } from './SubmitFooterActions';
import { SubmitFooterAiInsightsButton, type SubmitFooterAiInsightsButtonProps } from './SubmitFooterAiInsightsButton';
import { SubmitFooterValidationMessages } from './SubmitFooterValidationMessages';

export type TimesheetSubmitFooterProps = SubmitFooterActionsProps &
  SubmitFooterAiInsightsButtonProps & {
    isDaily: boolean;
    isSubmitted: boolean;
  };

/** Sticky bottom action bar: validation messages on the left, actions on the right. */
export function TimesheetSubmitFooter({
  isDaily,
  isSubmitted,
  enableAiInsights,
  aiWarningsCount,
  onOpenAiInsights,
  ...actionsProps
}: TimesheetSubmitFooterProps) {
  const {
    isReadOnly,
    entriesCount,
    hasMissingProjects,
    hasMissingDescriptions,
    hasMissingCostCentres,
    hasMissingRoles,
    hasBlockingPolicyViolation,
  } = actionsProps;

  if (isReadOnly && !isSubmitted && aiWarningsCount === 0) return null;

  return (
    <div className="flex-shrink-0 bg-background border-t border-border">
      <div className="px-3 pt-2 pb-3 sm:px-4 sm:pt-2 sm:pb-4">
        <div className="flex items-center gap-3 justify-between">
          {/* Left: Validation messages */}
          <div className="flex-1 min-w-0">
            <SubmitFooterValidationMessages
              isReadOnly={isReadOnly}
              isDaily={isDaily}
              entriesCount={entriesCount}
              hasMissingProjects={hasMissingProjects}
              hasMissingDescriptions={hasMissingDescriptions}
              hasMissingCostCentres={hasMissingCostCentres}
              hasMissingRoles={hasMissingRoles}
              hasBlockingPolicyViolation={hasBlockingPolicyViolation}
            />
          </div>
          {/* Right: Action Buttons */}
          <div className="flex items-center gap-2 flex-shrink-0">
            <SubmitFooterAiInsightsButton
              enableAiInsights={enableAiInsights}
              aiWarningsCount={aiWarningsCount}
              onOpenAiInsights={onOpenAiInsights}
            />
            <SubmitFooterActions {...actionsProps} />
          </div>
        </div>
      </div>
    </div>
  );
}
